import type { Venue } from '@brent/shared/types'
import apiClient from './client'

export interface VenueListResponse {
  venues: Venue[]
}

export interface VenueConcert {
  concert_id: number
  date_text: string | null
  date_iso: string | null
  year: number | null
  ensemble_name: string | null
  programme_count: number
}

export interface VenueDetailResponse {
  venue: Venue
  concerts: VenueConcert[]
}

export interface UpdateVenueInput {
  quality_score?: string
  wikidata_id?: string
}

export interface UpdateVenueResponse {
  ok: boolean
  enriched?: {
    label: string
    description: string
    birth_year: number
    death_year: number
  }
  cleared?: boolean
  error?: string
}

export async function fetchVenues(): Promise<Venue[]> {
  const response = await apiClient.get<VenueListResponse>('/venues')
  return response.venues
}

export async function fetchVenue(id: number): Promise<VenueDetailResponse> {
  return apiClient.get<VenueDetailResponse>(`/venues/${id}`)
}

export async function updateVenue(
  id: number,
  input: UpdateVenueInput,
): Promise<UpdateVenueResponse> {
  return apiClient.put<UpdateVenueResponse>(`/venues/${id}`, input)
}
